module.exports = __webpack_public_path__ + "static/img/answer-a-few-questions-and-get-recommended-documents.05246e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/answer-a-few-questions-and-get-recommended-documents.png
// module id = VNQZ
// module chunks = 0